import * as React from "react";

function Update(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 20 24" fill="none" {...props}>
      <path
        d="M12.777 6.81l-2.02-4.04 4.04-2.02"
        stroke="#333"
        strokeWidth={1.5}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.85 2.868c4.5.55 7.898 4.132 7.898 8.907 0 4.315-2.755 7.896-6.52 8.998M6.721 16.825l2.02 4.04-3.949 1.928"
        stroke="#333"
        strokeWidth={1.5}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.648 20.768C4.24 20.218.75 16.636.75 11.77c0-4.316 2.755-7.897 6.52-8.999"
        stroke="#333"
        strokeWidth={1.5}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default Update;
